module.exports = __webpack_public_path__ + "img/flatfare.067319cc.svg";